import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUsuarioPorId } from 'services/servicioGet';
import { UsuarioDTO } from 'utils/models/types';

interface UsuarioIdState {
  usuario: UsuarioDTO | null;
  loadingUsuario: boolean;
  errorUsuario: string | null;
}

// Estado inicial del slice
const initialState: UsuarioIdState = {
  usuario: null,
  loadingUsuario: false,
  errorUsuario: null,
};

// Thunk para obtener el usuario
export const fetchUsuarioId = createAsyncThunk<UsuarioDTO, number, { rejectValue: string }>(
  'fetchUsuarioId',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getUsuarioPorId(id.toString());
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de usuario por Id
const usuarioIdSlice = createSlice({
  name: 'usuario',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchUsuarioId.pending, state => {
        state.loadingUsuario = true;
        state.errorUsuario = null;
      })
      .addCase(fetchUsuarioId.fulfilled, (state, action) => {
        state.usuario = action.payload;
        state.loadingUsuario = false;
      })
      .addCase(fetchUsuarioId.rejected, (state, action) => {
        state.loadingUsuario = false;
        state.errorUsuario = action.payload as string;
      });
  },
});

export default usuarioIdSlice.reducer;
